<template>
  <div>
    <v-row dense class="mx-2 mb-4" align="start">
      <v-col class="text-left">
        <div class="text-h4">Ligações</div>
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" multiple focusable class="mb-n6">
      <v-expansion-panel readonly>
        <v-expansion-panel-header hide-actions>
          <div class="text-center font-weight-bold">
            <v-row dense>
              <v-col cols="2" class="text-left">Data/Hora</v-col>
              <v-col cols="2" class="pl-4 text-left">Origem</v-col>
              <v-col cols="2" class="pl-4 text-left">Destino</v-col>
              <v-col cols="2" class="pl-3 text-left">Status</v-col>
              <v-col cols="2" class="text-left">Tempo Total</v-col>
              <v-col cols="2" class="text-left">Conversação</v-col>
            </v-row>
          </div>
        </v-expansion-panel-header>
      </v-expansion-panel>
      <v-expansion-panel v-for="(item, i) in dadosRelatorio" :key="`received_call_${i}`">
        <v-expansion-panel-header ripple>
          <div class="text-center">
            <v-row dense>
              <v-col cols="2" class="text-left">{{ convertDateFormat(item.dateStartCall) }}</v-col>
              <v-col cols="2" class="text-left pl-5">{{ item.numeroOrigem }}</v-col>
              <v-col cols="2" class="text-left pl-6">{{ item.numeroDestino }}</v-col>
              <v-col cols="2" class="text-left pl-6">{{ statusObject[`${item.status}`] }}</v-col>
              <v-col cols="2" class="text-left pl-6">
                {{ getAnyTimeCall(item.status, item.dateStartCall, item.dateEndCall) }}
              </v-col>
              <v-col cols="2" class="text-left pl-6">
                {{ getAnyTimeCall(item.status, item.dataAtdCall, item.dateEndCall) }}
              </v-col>
            </v-row>
          </div>
          <template v-slot:actions>
            <v-icon color="orangePcm">$expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="background">
          <v-timeline dense>
            <TimelineFirstItem :item="item" />

            <div v-if="item.eventos">
              <div v-for="(evento, key) in item.eventos" :key="`evento_call_${key}`">
                <TimeLineTransferenciaConf
                  v-if="evento.acao && obtemAcao(evento.acao) === 'DiscarConferencia'"
                  :evento="evento"
                />
                <TimeLineEventoTransferencia v-else-if="evento.tipoChamada === 'transferencia' || evento === 'Chamada transferida'" :evento="evento" />
                <TimeLineBlindTransfer v-else-if="evento.tipoChamada === 'BLINDTRANSFER'" :evento="evento" />
              </div>
            </div>

            <TimelineLastItem :item="item" v-if="item.status === 'atendida'" />
          </v-timeline>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-for="n in 4" :key="`divider_${n}`">
      <v-divider vertical />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import relatorioChamadasStore from '../_store'

import TimelineFirstItem from '../_components/TimelineFirstItem'
import TimelineLastItem from '../_components/TimelineLastItem'
import TimeLineBlindTransfer from '../_components/TimeLineBlindTransfer'
import TimeLineEventoTransferencia from '../_components/TimeLineEventoTransferencia'
import TimeLineTransferenciaConf from '../_components/TimeLineTransferenciaConf'

import { sharedData } from '../_utils/sharedData'
import { sharedMethods } from '../_utils/sharedMethods'

export default {
  components: {
    TimelineFirstItem,
    TimelineLastItem,
    TimeLineBlindTransfer,
    TimeLineEventoTransferencia,
    TimeLineTransferenciaConf,
  },
  props:['panel'],
  data: () => ({
    dadosRelatorio: [],
    ...sharedData,
  }),

  computed: {
    ...mapGetters('relatorioLigacoesModuloRelatoriosLigacoes', ['getDadosRelatorio']),
  },

  async created() {
    registerVuexModule(this.$store, 'relatorioLigacoesModuloRelatoriosLigacoes', relatorioChamadasStore)
  },

  methods: {
    ...sharedMethods,
  },

  watch: {
    getDadosRelatorio: {
      deep: true,
      handler() {
        this.dadosRelatorio = [...this.getDadosRelatorio.data]
      },
    },
  }
}
</script>
